import script from "./ImageSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageSlider.vue?vue&type=script&lang=ts&setup=true"

import "./ImageSlider.vue?vue&type=style&index=0&id=ab475662&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab475662"]])

export default __exports__